import translations from '../lang';

export const fetchWrapper = (
  endpointUrl,
  authRequestHeader,
  method = 'GET',
  body,
  conf = {
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    mapBody: JSON.stringify,
  },
  no_content
) => {
  const getElementsCount = (response) => {
    const pageCount = response.headers.get('x-total-count');
    if (pageCount) {
      return parseInt(pageCount);
    }

    return false;
  };

  const getRedirectUrl = (response) => {
    const location = response.headers.get('location');

    return location;
  };

  const handleStatusErrors = async ({ response, json }) => {
    const mapErrorsMessages = {
      500: translations['en-US'].COMMON.GENERIC_ERROR,
      401: translations['en-US'].COMMON.UNAUTHORIZED,
      400: translations['en-US'].COMMON.GENERIC_ERROR,
      404: translations['en-US'].COMMON.NOT_FOUND,
    };

    if (!response.ok) {
      const error = {
        status: response.status,
        code: json?.code,
        message: json?.message || mapErrorsMessages[response.status],
      };

      return Promise.reject(error);
    }
    return { response, json };
  };

  return fetch(endpointUrl, {
    headers: {
      ...authRequestHeader,
      ...conf.headers,
    },
    method,
    body: conf.mapBody(body),
  })
    .then(async (response) => {
      if (response.status === 204 || response.status === 500) {
        return { response, json: null };
      } else {
        if (no_content) {
          return { response, json: {} };
        }

        const json = await response.json();
        return { response, json };
      }
    })
    .then(handleStatusErrors)
    .then(({ response, json }) => {
      const totalCount = getElementsCount(response);
      const redirectUrl = getRedirectUrl(response);

      if (!json) {
        return {};
      }

      return {
        data: json,
        total_count: totalCount || 0,
        redirectUrl,
      };
    })
    .then((response) => {
      return { response };
    })
    .catch((error) => {
      return { error };
    });
};

export default fetchWrapper;
